import {  GET_AUDIO, GET_AUDIOS, AGGIUNGI_AUDIO, MODIFICA_AUDIO, ELIMINA_AUDIO, AUDIO_ERROR } from '../actions/types';

const initialState = {
    audios: [],
    audioElement: null,
    loading: true
}
export default function(state = initialState, action){
    const { type, payload } = action;
    switch(type){
        case GET_AUDIOS:
            return {
                ...state,
                audios: payload,
                loading: false
            };
        case GET_AUDIO:
            return {
                ...state,
                audioElement: payload,
                loading: false
            };
        case MODIFICA_AUDIO:
            return {
                ...state,
                audioElement: payload,
                loading: false
            };
        case AGGIUNGI_AUDIO:
            let arrayAudio = [...state.audios];
            arrayAudio.push(payload);
            return {
                ...state,
                audios: arrayAudio,
                loading: false
            };
        case ELIMINA_AUDIO:
                return {
                  ...state,
                  audios: state.audios.filter(audio => audio._id !== payload._id),
                  loading: false
                };
        case AUDIO_ERROR:
            return {
                ...state,
                loading: false,
            };
        default:
            return state;
    }
}